import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {EmissionService} from 'services/emission.service';
import {Constants} from 'config/constants';
import {SpinnerService} from 'services/spinner.service';

@Component({
    selector: 'tpc-individual-length',
    templateUrl: './individual-length.component.html',
    styleUrls: ['./individual-length.component.css']
})
export class IndividualLengthComponent implements  OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmitted = false;

    public form: FormGroup;

    constructor(protected footerService: FooterNavbarService,
                protected emissionService: EmissionService,
                private fb: FormBuilder,
                protected spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
    }

    private createForm() {
        this.form = this.fb.group({
            countShort: [0, this.getValidationParameters()],
            countMedEcon: [0, this.getValidationParameters()],
            countMedFirst: [0, this.getValidationParameters()],
            countLongEcon: [0, this.getValidationParameters()],
            countLongEconPlus: [0, this.getValidationParameters()],
            countLongBusiness: [0, this.getValidationParameters()],
            countLongFirst: [0, this.getValidationParameters()]
        });
    }

    next(): void {
        let calculatorName = Constants.calculators.individual;
        let categoryName = Constants.categories.individual.travel;
        let params = {
            calculateBy: 'byCount',
            // always need to use round trip calculations
            roundCountLongBusiness: true,
            roundCountLongEcon: true,
            roundCountLongEconPlus: true,
            roundCountLongFirst: true,
            roundCountLongSU: true,
            roundCountMedEcon: true,
            roundCountMedFirst: true,
            roundCountMedSU: true,
            roundCountShort: true,

            countShort: this.getFV('countShort'),
            countMedEcon: this.getFV('countMedEcon'),
            countMedFirst: this.getFV('countMedFirst'),
            countLongEcon: this.getFV('countLongEcon'),
            countLongEconPlus: this.getFV('countLongEconPlus'),
            countLongBusiness: this.getFV('countLongBusiness'),
            countLongFirst: this.getFV('countLongFirst'),
            countLongSU: 0,
            countMedSU: 0
        };

        if (!!+params.countShort || !!+params.countMedEcon || !!+params.countMedFirst || !!+params.countLongEcon ||
            !!+params.countLongEconPlus || !!+params.countLongBusiness || !!+params.countLongFirst) {
            this.spinner.show();
            this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
                response => {
                    let input = response.body[0].input[0];

                    this.emissionService.setEmission({
                        category: categoryName,
                        emission: {
                            emission: input.emmission,
                            emissionTrees: input.emissionTrees,
                            DollarAmt: input.DollarAmt,
                            DollarAmtMonthly: input.DollarAmtMonthly
                        }
                    });
                    this.footerService.skip();
                    this.spinner.hide();
                }
            );
        } else {
            this.emissionService.setEmission({
                category: categoryName,
                emission: {
                    emission: 0,
                    emissionTrees: 0,
                    DollarAmt: 0,
                    DollarAmtMonthly: 0
                }
            });
            this.footerService.skip();
        }
    }

    private getValidationParameters() {
        return [Validators.required, CustomValidators.min(0), CustomValidators.max(999),
            CustomValidators.digits];
    }

    getFV(param) {
        return this.form.get(param).value;
    }

    checkError(param) {
        return this.form.get(param).status === 'INVALID' && (this.isFormSubmitted || this.form.get(param).touched);
    }

    ngOnDestroy() {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-length/individual-length.component.ts